import { Icon } from '@cb/apricot-react';
import Link from '../Link';
import styles from '../../../../sass/status.module.scss';
import { formatDateTime } from '../../../date';
function SubmitOrderLink(_ref) {
  var allowedToOrder = _ref.allowedToOrder,
    path = _ref.path,
    history = _ref.history;
  return /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: path,
    className: "cb-btn cb-btn-sm cb-btn-yellow ".concat(styles['submit-order-button']).concat(allowedToOrder ? '' : ' disabled')
  }, "Review & Submit Order");
}
function ShipmentsLink(_ref2) {
  var subOrderProcessing = _ref2.subOrderProcessing,
    history = _ref2.history;
  if (subOrderProcessing) {
    return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: "/orders/shipments",
      className: "cb-btn cb-btn-naked cb-no-padding cb-no-outline"
    }, "View Shipments ", /*#__PURE__*/React.createElement(Icon, {
      name: "east"
    })));
  }
  return null;
}
function NotSubmitted(_ref3) {
  var allowedToOrder = _ref3.allowedToOrder,
    numberTakingExam = _ref3.numberTakingExam,
    regularOrderingDisplayDeadline = _ref3.regularOrderingDisplayDeadline,
    history = _ref3.history;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-h5"
  }, "Not submitted"), !allowedToOrder ? /*#__PURE__*/React.createElement("p", null, "You cannot submit your order until you", ' ', /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/settings?scroll=participationFormPanel",
    className: "cb-btn cb-btn-naked cb-no-padding cb-no-outline"
  }, /*#__PURE__*/React.createElement("strong", null, "complete the participation form."))) : numberTakingExam > 0 ? /*#__PURE__*/React.createElement(SubmitOrderLink, {
    path: "/orders",
    allowedToOrder: allowedToOrder,
    history: history
  }) : /*#__PURE__*/React.createElement("p", null, "You have no exams identified for your order."), /*#__PURE__*/React.createElement("div", {
    className: styles['order-deadline']
  }, "Order deadline:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, formatDateTime(regularOrderingDisplayDeadline))));
}
function Submitted(_ref4) {
  var subOrderProcessing = _ref4.subOrderProcessing,
    history = _ref4.history;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-h5"
  }, "Submitted"), /*#__PURE__*/React.createElement("p", null, "You will be notified when your exam materials ship."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/orders/history",
    className: "cb-btn cb-btn-naked cb-no-padding cb-no-outline"
  }, "View Order Details ", /*#__PURE__*/React.createElement(Icon, {
    name: "east"
  }))), /*#__PURE__*/React.createElement(ShipmentsLink, {
    subOrderProcessing: subOrderProcessing,
    history: history
  }));
}
function UnsubmittedChanges(_ref5) {
  var subOrderProcessing = _ref5.subOrderProcessing,
    history = _ref5.history;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-h5"
  }, "Unsubmitted Changes"), /*#__PURE__*/React.createElement("p", null, "You must submit before your changes are applied."), /*#__PURE__*/React.createElement(SubmitOrderLink, {
    path: "/orders/unsubmitted"
  }), /*#__PURE__*/React.createElement(ShipmentsLink, {
    subOrderProcessing: subOrderProcessing,
    history: history
  }));
}
function PanelBody(_ref6) {
  var allowedToOrder = _ref6.allowedToOrder,
    subOrderProcessing = _ref6.subOrderProcessing,
    orderStatus = _ref6.orderStatus,
    changeOrderStatus = _ref6.changeOrderStatus,
    regularOrderingDisplayDeadline = _ref6.regularOrderingDisplayDeadline,
    numberTakingExam = _ref6.numberTakingExam,
    history = _ref6.history;
  var hasUnsubmittedChanges = changeOrderStatus === 'NOT_SUBMITTED';
  var isSubmitted = orderStatus === 'SUBMITTED';
  if (hasUnsubmittedChanges) {
    return /*#__PURE__*/React.createElement(UnsubmittedChanges, {
      subOrderProcessing: subOrderProcessing,
      history: history
    });
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(Submitted, {
      subOrderProcessing: subOrderProcessing,
      history: history
    });
  }
  return /*#__PURE__*/React.createElement(NotSubmitted, {
    allowedToOrder: allowedToOrder,
    numberTakingExam: numberTakingExam,
    regularOrderingDisplayDeadline: regularOrderingDisplayDeadline,
    history: history
  });
}
function Order(_ref7) {
  var _ref7$allowedToOrder = _ref7.allowedToOrder,
    allowedToOrder = _ref7$allowedToOrder === void 0 ? false : _ref7$allowedToOrder,
    subOrderProcessing = _ref7.subOrderProcessing,
    orderStatus = _ref7.orderStatus,
    changeOrderStatus = _ref7.changeOrderStatus,
    history = _ref7.history,
    regularOrderingDisplayDeadline = _ref7.regularOrderingDisplayDeadline,
    _ref7$numberTakingExa = _ref7.numberTakingExam,
    numberTakingExam = _ref7$numberTakingExa === void 0 ? 0 : _ref7$numberTakingExa;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['status-panel-container']
  }, /*#__PURE__*/React.createElement(PanelBody, {
    allowedToOrder: allowedToOrder,
    subOrderProcessing: subOrderProcessing,
    orderStatus: orderStatus,
    changeOrderStatus: changeOrderStatus,
    regularOrderingDisplayDeadline: regularOrderingDisplayDeadline,
    numberTakingExam: numberTakingExam,
    history: history
  }));
}
export default Order;